<template>
  <div class="relative">
  <div class="material-master-create s p-4">
    <div :class="{ 'sequence-template-rule-locked': isSequenceTemplateControlledByActiveRule() }">
       <part-id-preview
       ref="materialPartIdPreview"
       :components="partIdRules"
       :showTemplateSelector = true
       v-if="showMaterialPartIdPreview"
       :featureId="config.CORE_FEATURES.MATERIAL"
       :showCopyMaterialCheckbox="view === 'material' && isEveryValueFilledForMaterialId"
       @sequenceIdSelected = "handleSequenceIdSelection"
       @update="updatePartIdValues"
       :title="view === 'material' ? 'Material Id Preview' : 'Resource Id Preview'"/>
    </div>
    <div class="mt-2">
       <part-id-preview
       :components="partIdRulesForProductCode"
       :disabled="!productCode"
       :showToggle="!bomForm"
       @sequenceIdSelected = "handleSequenceIdSelectionForProductCode"
       :showTemplateSelector = true
       :featureId="config.CORE_FEATURES.PRODUCT_CODE"
       v-if="showProductPartIdPreview && view !== 'resource'"
       @update="updatePartIdValuesForProductCode"
       @togglePartIdGeneration="handleTogglePartIdGenerationForProductCode"
       title="Product Code Preview"/>
    </div>
    <div class="mt-2" :class="(showMaterialPartIdPreview && !showProductPartIdPreview) || view !== 'material'? '' : 'grid-2'">
      <div class="input-group imp" data-validation="CustomMaterialId" v-if="!showMaterialPartIdPreview">
        <label v-if="view === 'material'" class="key">Material Id:</label>
        <label v-else class="key">Resource Id:</label>
        <input type="text" v-model="materialMaster.custom_material_id" :disabled="isMaterialFieldControlledByActiveRule('custom_material_id')" />
      </div>
      <div :class="getFixedFieldInputGroupClass('material_name', ['input-group', 'imp'])" data-validation="CustomMaterialName">
        <label v-if="view === 'material'" class="key">Material Name:</label>
        <label v-else class="key">Resource Name:</label>
        <input type="text" v-model="materialMaster.material_name" :disabled="isMaterialFieldControlledByActiveRule('material_name') || sequenceAsName" />
      </div>
      <div :class="getFixedFieldInputGroupClass('material_type', ['input-group', 'imp'])" v-if="view === 'material' && showProductPartIdPreview">
    <label class="key">Type:</label>
    <custom-dropdown
      :list="customListType"
      :selected="selectedMaterialType"
      :disabled="isMaterialFieldControlledByActiveRule('material_type')"
      :prevent-deselection="true"
      :enable-search="true"
      default-label="Select Type"
      @select="handleMaterialTypeSelection"
    />
    </div>
    </div>
    <div v-if="view === 'material'" class="grid-2 mt-2">
      <div :class="getFixedFieldInputGroupClass('unit_of_material', ['input-group', 'imp'])" data-validation="UnitOfMaterial">
        <label class="key">Unit Of Material:</label>
        <custom-dropdown
          v-if="materialMaster.type === 2"
          :list="resourceUnit.id ? [resourceUnit] : []"
          :selected="resourceUnit"
          :disabled="true"
          :prevent-deselection="true"
          :enable-search="true"
          default-label="Select Unit"
        />
        <custom-dropdown
          v-else
          :list="list_of_unit_of_material"
          :selected="selectedUnitOfMaterial"
          :disabled="isMaterialFieldControlledByActiveRule('unit_of_material')"
          :prevent-deselection="true"
          :enable-search="true"
          default-label="Select Unit"
          @select="handleUnitOfMaterialSelection"
        />
      </div>
      <div :class="getFixedFieldInputGroupClass('plm_material_id', 'input-group')" data-validation="PlmMaterialId">
        <label v-if="view === 'material'" class="key">PLM Material Id:</label>
        <label v-else class="key">PLM Resource Id:</label>
        <input type="text" v-model="materialMaster.plm_material_id" :disabled="isMaterialFieldControlledByActiveRule('plm_material_id')" />
      </div>
    </div>
    <!-- <div class="mt-2 new-product">
        <div class="input-group mt-2" :class="bomForm ? ' imp' : ''">
          <label class="key">Product Code:</label>
          <input type="text" v-model="productCodeName" />
        </div>
    </div> -->
    <div class="mt-2" v-if="!showProductPartIdPreview &&  view !== 'resource'" :class=" view !== 'material' ? '' : 'grid-2'">
      <div :class="['input-group mt-2',{'imp': bomForm}]">
          <label class="key">Product Code:</label>
          <input type="text" v-model="productCodeName"/>
    </div>
        <div :class="getFixedFieldInputGroupClass('material_type', ['input-group', 'mt-2', 'imp'])"  v-if="view === 'material'">
          <label class="key">Type:</label>
          <custom-dropdown
            :list="customListType"
            :selected="selectedMaterialType"
            :disabled="isMaterialFieldControlledByActiveRule('material_type')"
            :prevent-deselection="true"
            :enable-search="true"
            default-label="Select Type"
            @select="handleMaterialTypeSelection"
          />
    </div>
  </div>
    <div v-if="moreInput">
    <div :class="getFixedFieldInputGroupClass('material_description', ['input-group', 'mt-2'])">
      <label v-if="view === 'material'" class="key">Material Description:</label>
      <label v-else class="key">Resource Description:</label>
      <textarea type="text" v-model="materialMaster.material_description" :disabled="isMaterialFieldControlledByActiveRule('material_description')" />
    </div>
    <div :class="getFixedFieldInputGroupClass('workflow_template_id', ['input-group', 'mt-2'])" v-if="view === 'material'">
      <label class="key">Workflow:</label>
       <custom-dropdown :disabled="materialMaster.material_type === materialType.Buy || isMaterialFieldControlledByActiveRule('workflow_template_id')" :list="filteredWorkflows" :selected="selectedWorkFlow" @select="handleWorkFlowSelection" @toggle="() => workflowSearchKeyword = ''" @deselect="handleWorkFlowSelection" class="form-template-container-wft">

  <template #before-items>
    <div class="fh center py-4" v-if="WFTLoading && workflows.length === 0"  >
          <loading-circle />
        </div>
    <div class="fh center py-4" v-else-if="!WFTLoading && workflows.length === 0"  >
         No Workflow Templates
        </div>
    <div class="fh center p-3 form-template-container-wft-search-box" v-else>
        <input type="text p-2" class="form-template-container-wft-input" v-model="workflowSearchKeyword"  placeholder="Search"/>
      </div>
      <div class="fh center py-4" v-if="workflows.length !== 0 && filteredWorkflows.length === 0"  >
       No Workflow Templates
      </div>
  </template>

  </custom-dropdown>
    </div>
    <div v-if="view === 'material'" class="grid-2 mt-2">
      <div :class="getFixedFieldInputGroupClass('plm_record_id', 'input-group')">
        <label class="key">PLM Record Id:</label>
        <input type="text" v-model="materialMaster.plm_record_id" :disabled="isMaterialFieldControlledByActiveRule('plm_record_id')" />
      </div>

    </div>
    <div class="mt-2" :class="view === 'resource' ? 'grid-2' : ''">
    <div v-if="view === 'material'" :class="getFixedFieldInputGroupClass('material_group', 'input-group')">
      <label class="key" @click="checkData">Material Group:</label>
      <custom-dropdown
        :list="list_of_material_group"
        :selected="selectedMaterialGroup"
        :disabled="isMaterialFieldControlledByActiveRule('material_group')"
        :prevent-deselection="true"
        :enable-search="true"
        default-label="Select Material Group"
        @select="handleMaterialGroupSelection"
      />
    </div>
    <div v-else class="input-group imp mt-2">
      <label class="key" @click="checkData" >Resource Type:</label>
      <custom-dropdown
        :list="list_of_material_group"
        :selected="selectedResourceType"
        :disabled="isMaterialFieldControlledByActiveRule('resource_type')"
        :prevent-deselection="true"
        :enable-search="true"
        default-label="Select Resource Type"
        @select="handleResourceTypeSelection"
      />
    </div>
<div v-if="view === 'resource'" class="input-group mt-2">
  <label class="key">Setup Time:</label>

  <div class="grid-2">
    <!-- Setup Time Value -->
    <input
      type="number"
      min="0"
      v-model.number="materialMaster.setup_time"
      :disabled="isMaterialFieldControlledByActiveRule('setup_time')"
      placeholder="Value"
      @keydown="changeNumber"
    />

    <!-- Duration Type -->
    <custom-dropdown
      :list="setupTimeDurationOptions"
      :selected="selectedSetupTimeDurationType"
      :disabled="isMaterialFieldControlledByActiveRule('setup_time_duration_type')"
      :prevent-deselection="true"
      :enable-search="true"
      default-label="Select Duration"
      @select="handleSetupTimeDurationTypeSelection"
    />
  </div>
</div>

      <!-- <div v-if="view === 'resource'" class="input-group mt-2">
        <label class="key">Resource State:</label>
        <select v-model="materialMaster.resource_state">
          <option v-for="item in resource_states" :value="item.id" :key="item.name" >{{item.name}}</option>
        </select>
      </div> -->
    </div>
    <div v-if="view === 'material'" class="grid-2 mt-2">
      <div :class="getFixedFieldInputGroupClass('gross_weight', 'input-group')" data-validation="GrossWeight">
        <label class="key">Gross Weight:</label>
        <input type="number" v-model.number="materialMaster.gross_weight" :disabled="isMaterialFieldControlledByActiveRule('gross_weight')" @keydown="changeNumber"/>
      </div>
      <div :class="getFixedFieldInputGroupClass('weight_unit', 'input-group')">
        <label class="key">Weight Unit:</label>
        <custom-dropdown
          :list="list_of_weight_unit"
          :selected="selectedWeightUnit"
          :disabled="isMaterialFieldControlledByActiveRule('weight_unit')"
          :prevent-deselection="true"
          :enable-search="true"
          default-label="Select Weight Unit"
          @select="handleWeightUnitSelection"
        />
      </div>
    </div>
    <div v-if="view === 'material'" class="grid-2 mt-2">
      <div :class="getFixedFieldInputGroupClass('unit_cost', 'input-group')" data-validation="UnitCost">
        <label class="key">Unit Cost:</label>
        <input type="number" v-model.number="materialMaster.unit_cost" :disabled="isMaterialFieldControlledByActiveRule('unit_cost')" @keydown="changeNumber"/>
      </div>
      <div :class="getFixedFieldInputGroupClass('unit_sale_price', 'input-group')" data-validation="UnitSalePrice">
        <label class="key">Unit Sale Price:</label>
        <input type="number" v-model.number="materialMaster.unit_sale_price" :disabled="isMaterialFieldControlledByActiveRule('unit_sale_price')" @keydown="changeNumber"/>
      </div>
    </div>
    <div v-if="view === 'material'" class="mt-2 grid-2">
      <div :class="getFixedFieldInputGroupClass('effective_date', 'sequence-template-effective-date')">
        <effectiveDate :date="materialMaster.effective_date" :disabled="isMaterialFieldControlledByActiveRule('effective_date')" @date-selected="createEffectiveDate" />
      </div>
      <div :class="getFixedFieldInputGroupClass('storage_loc', 'input-group')">
        <label class="key">Storage Loc:</label>
        <custom-dropdown
          :list="list_of_address_location"
          :selected="selectedStorageLocation"
          :disabled="isMaterialFieldControlledByActiveRule('storage_loc') || list_of_address_location.length === 0"
          :prevent-deselection="true"
          :enable-search="true"
          :default-label="list_of_address_location.length === 0 ? 'No address locations available.' : 'Select Storage Location'"
          @select="handleStorageLocationSelection"
        />
      </div>
    </div>
    <div v-if="view === 'material'" class="grid-2 mt-2">
      <!-- <div class="input-group">
        <label class="key">Lead Time:</label>
        <input type="number" v-model.number="materialMaster.lead_time" @keydown="changeNumber"/>
      </div> -->
    </div>
    <div class="grid-1 mt-2">
      <div>
        <label class="key"  >Tags</label>
        <tagInput ref="tagSelector" title="Add tags to material"  :type="1"  :allowMultipleRoots="true" :lastParentId="tagGroupData?.tagArray[selected_tag_line]?.at(-1)?.id" @addNewTag="addnewTag" :tagGroupData="tagGroupData" @parentLevelSelected="changeSelectedTagLine" @resetSelectedLine="resetSelectedTagLine" @focusTagLevel="focusTagLevel"/>
      </div>
    </div>
    <div class="grid-1 mt-2">
      <label class="key">
        Document:</label>
        <div class="document-attach" >
          <div v-if="selectedFileData.length > 0 " class="weight-500 document-attach-view input-group imp " ><div v-for="file in selectedFileData" :key="file.id" class="document-attach-list" v-overflow-tooltip>{{ file.doc_name }}</div></div>
          <div v-tooltip="'Link Documents '" class="document-attach-edit" @click="documentSelectDialog = true"> <img src="~@/assets/images/icons/file-icon.svg" width="10px" height="10px" alt="" >
          </div>
          </div>
    </div>
  </div>
  <div class="input-group mt-3" v-show="moreInput && view === 'material'">
      <label>{{ formTemplateData.name }}</label>
    </div>
        <div class="view-form" v-show="moreInput && view === 'material'">
          <div class=" form-grid mt-2">
            <template v-for="(ele, index) in templateField">
            <div  :key="index" v-if="!ele.autogenerated" :class="['form-grid__item','form-grid__item--span-2']" >
            <component
              :ref="ele.field_id"
              :is="ele.form_field.key + '_COMPONENT'"
              :data="getResolvedTemplateField(ele)"
              :value="dynamicFieldValues[ele.field_id]"
              :viewOnly="isDynamicFieldControlledByActiveRule(ele.field_id)"
              @customChange="handleDynamicFieldChange"
              mode="CREATE"
              :formTemplate="true"
              :templateId="formTemplateData.id"
              :fieldId="ele.field_id"
            />
            </div>
          </template>
        </div>
        </div>
  <div class="mt-2 m underline pointer" @click="toggleMore">
    <span v-if="moreInput">
      Show less
    </span>
    <span v-else>
      Add More Details
    </span>
  </div>
  <modal
    :open="documentSelectDialog"
    @close="documentSelectDialog = false"
    :closeOnOutsideClick="true"
    title=""
    >
    <document-selector @close="documentSelectDialog = false" :restrictUpload="true" @files-selected="handleFileSelection" :material-attachment="true"/>
  </modal>
  </div>
  <div class="flex flex-end pt-3 m">
    <div>
      <button class="btn btn-cancel mr-3 pointer" @click="$emit('close')">CANCEL</button>
      <button class="btn pointer" :disabled="addProduct || buttonDisabled"  @click="createMaterialMasterNew">
        SAVE
      </button>
    </div>
  </div>
  </div>
</template>

<script>
import {
  CreateMaterialMasterData,
  CreateProductCodeData,
  AddMaterialTags,
  UnitOfMaterial,
  WeightUnit,
  AddressLocation,
  CheckMaterialID,
  ResourceState,
  ResourceGroup,
  getDetailFormTemplate,
  SaveFormData,
  attachDocToMaterail,
  createMaterialMaster,
  getGivenCustomListsData,
  getFullWorkFLowTemplates,
  GetMaterialCustomList,
  getResourceTypes,
  CheckCustomMaterialIdExistence,
  CheckProductCodeExistence
} from '@/api'
import MaterialMasterValidation from '@/helper/formValidation/materialMaster.js'
import config from '../../config'
import { success, alert } from '@/plugins/notification'
import Loader from '@/plugins/loader'
import TagInput from '../common/tagAndConfigListInput.vue'
import { mapGetters, mapMutations } from 'vuex'
import effectiveDate from '../../components/common/effectiveDate.vue'

import Modal from '../common/modal.vue'
import DocumentSelector from '../document/documentSelectorDialog.vue'
import { TagTrie } from '@/utils/tagsHelper'
import timeComponent from '@/components/form/elements/timeComponent.vue'
import configurationList from '@/components/form/elements/configurationList.vue'
import fileComponent from '@/components/form/elements/fileComponent.vue'
import dateComponent from '@/components/form/elements/dateComponent.vue'
import longTextComponent from '@/components/form/elements/longTextComponent.vue'
import numberComponent from '@/components/form/elements/numberComponent.vue'
import switchComponent from '@/components/form/elements/switchComponent.vue'
import textComponent from '@/components/form/elements/textComponent.vue'
import companyComponent from '@/components/form/elements/companyComponent.vue'
import userComponent from '@/components/form/elements/userComponent.vue'
import multiUserComponent from '@/components/form/elements/multiUserComponent.vue'
import materialComponent from '@/components/form/elements/materialComponent.vue'
import locationComponent from '@/components/form/elements/locationComponent.vue'
import tableTemplate from '../../views/SETTINGS/tableTemplate.vue'
import productCodeComponent from '@/components/form/elements/productCodeComponent.vue'
import partIdPreview from '../common/partIdPreview.vue'
import customDropdown from '../common/customDropdown.vue'
import LoadingCircle from '../common/loadingCircle.vue'
import { restrictKeys } from '@/utils/validations'
import { GetTenantConfigTypes } from '@/api/apis/tenantConfigFeature'
import { startGlobalCursorLoader, stopGlobalCursorLoader } from '@/utils/globalCursorLoader'
import { getRulesApi } from '@/api/apis/configuration.js'
import {
  evaluateValidationRule,
  getActionFieldId,
  getActionMetadataValue,
  normalizeRuleKey,
  shouldBypassValidationRule
} from '@/utils/runtimeValidationRules'

export default {
  components: {
    TagInput,
    effectiveDate,
    Modal,
    DocumentSelector,
    BOOLEAN_COMPONENT: switchComponent,
    NUMBER_COMPONENT: numberComponent,
    TEXT_COMPONENT: textComponent,
    LONG_TEXT_COMPONENT: longTextComponent,
    DATE_COMPONENT: dateComponent,
    TIME_COMPONENT: timeComponent,
    CONFIGURATION_LIST_COMPONENT: configurationList,
    ATTACHMENT_COMPONENT: fileComponent,
    COMPANY_COMPONENT: companyComponent,
    USER_COMPONENT: userComponent,
    MULTI_USER_COMPONENT: multiUserComponent,
    MATERIALS_COMPONENT: materialComponent,
    LOCATION_COMPONENT: locationComponent,
    PRODUCT_CODE_COMPONENT: productCodeComponent,
    TABLE_COMPONENT: tableTemplate,
    customDropdown,
    partIdPreview,
    LoadingCircle
  },
  name: 'CreateMaterialMaster',
  props: {
    bomForm: {
      type: Boolean,
      default: false
    },
    open: {
      type: Boolean,
      default: false
    },
    view: {
      type: String,
      default: 'material'
    },
    pluginFixedFields: {
      type: Object,
      default: () => ({})
    },
    pluginContext: {
      type: Object,
      default: () => ({})
    }
  },
  data: () => ({
    isEveryValueFilledForMaterialId: false,
    config: config,
    sequenceIdForMaterialId: null,
    sequenceIdForProductCode: null,
    productCode: false,
    showMaterialPartIdPreview: true,
    showProductPartIdPreview: true,
    WFTLoading: true,
    workflows: [],
    partIdRules: [],
    partIdValues: [],
    partIdValuesForProductCode: [],
    materialType: {},
    materialName: 'Material Group',
    type: [{ name: 'Material', id: 1 }, { name: 'Resource', id: 2 }],
    documentSelectDialog: false,
    addProduct: false,
    productCodeName: '',
    resourceUnit: {},
    selectedFileData: [],
    materialMaster: {
      custom_material_id: null,
      gross_weight: null,
      lead_time: null,
      material_description: null,
      material_group: null,
      resource_state: null,
      material_name: null,
      effective_date: null,
      plm_material_id: null,
      plm_record_id: null,
      unit_cost: null,
      storage_loc: null,
      unit_of_material: null,
      unit_sale_price: null,
      weight_unit: null,
      type: null,
      form_id: null,
      source: 4,
      material_type: null,
      resource_type: null,
      workflow_template_id: null
    },
    moreInput: false,
    list_of_unit_of_material: [],
    partIdRulesForProductCode: [],
    list_of_weight_unit: [],
    resource_states: [],
    list_of_material_group: [],
    list_of_address_location: [],
    selectedTags: [],
    weight_unit: null,
    tagGroupData: {
      firstLevelParents: [],
      tagArray: []
    },
    hoverd_tag: {
      cindex: null,
      index: null
    },
    selected_tag_line: 0,
    tagTrie: new TagTrie(),
    lastParentId: null,
    window: window,
    buttonDisabled: false,
    formTemplateData: {},
    templateId: '',
    loading: true,
    selectedWorkFlow: {},
    workflowSearchKeyword: '',
    customListType: [],
    validationErrors: '', // this is for getting valiadtion errors
    dynamicFieldValues: {},
    isApplyingValidationResults: false,
    runtimeValidationRules: [],
    runtimeValidationEvaluations: {},
    runtimeControlledFields: {},
    matchedSequenceTemplateId: null,
    sequenceAsName: false
  }),
  computed: {
    ...mapGetters('tag', ['getTags']),
    ...mapGetters(['isOnProjectLevel', 'tenantDefaultsData']),
    selectedMaterialType () {
      return this.findOptionById(this.customListType, this.materialMaster.material_type)
    },
    selectedUnitOfMaterial () {
      return this.findOptionById(this.list_of_unit_of_material, this.materialMaster.unit_of_material)
    },
    selectedMaterialGroup () {
      return this.findOptionById(this.list_of_material_group, this.materialMaster.material_group)
    },
    selectedResourceType () {
      return this.findOptionById(this.list_of_material_group, this.materialMaster.resource_type)
    },
    setupTimeDurationOptions () {
      return [
        { id: 3, name: 'Minutes' },
        { id: 2, name: 'Hours' },
        { id: 1, name: 'Days' }
      ]
    },
    selectedSetupTimeDurationType () {
      return this.findOptionById(this.setupTimeDurationOptions, this.materialMaster.setup_time_duration_type)
    },
    selectedWeightUnit () {
      return this.findOptionById(this.list_of_weight_unit, this.materialMaster.weight_unit)
    },
    selectedStorageLocation () {
      return this.findOptionById(this.list_of_address_location, this.materialMaster.storage_loc)
    },
    filteredWorkflows () {
      if (!this.workflowSearchKeyword.length) return this.workflows
      return this.workflows.filter(item => {
        return item.name.toLowerCase().includes(this.workflowSearchKeyword.toLowerCase())
      })
    },
    templateField () {
      if (this.formTemplateData && this.formTemplateData.template_versions) {
        const activeVersion =
        this.formTemplateData.template_versions.find((item) => item.active) ||
        {}
        return activeVersion.template_fields || []
      }
      return []
    },
    sequenceTemplateMandatoryFields () {
      const mandatoryFields = {
        MATERIAL_FIXED_FIELDS: [],
        STANDARD_MATERIAL_FORM: []
      }
      const activeSequenceTemplateId = this.sequenceIdForMaterialId

      if (!activeSequenceTemplateId) {
        return mandatoryFields
      }

      const fixedFieldIds = new Set()
      const dynamicFieldIds = new Set()

      this.runtimeValidationRules.forEach((validation) => {
        if (normalizeRuleKey(validation?.target) !== 'SEQUENCE_TEMPLATE') return
        if (!this.runtimeValidationEvaluations?.[validation.id]) return

        const actions = Array.isArray(validation?.trigger_actions) ? validation.trigger_actions : []
        actions.forEach((action) => {
          if (action?.sequence_template_id !== activeSequenceTemplateId) return

          const metadata = this.normalizeSequenceTemplateMandatoryMetadata(action?.metadata)
          const nextFixedFieldIds = Array.isArray(metadata?.MATERIAL_FIXED_FIELDS) ? metadata.MATERIAL_FIXED_FIELDS : []
          const nextDynamicFieldIds = Array.isArray(metadata?.STANDARD_MATERIAL_FORM) ? metadata.STANDARD_MATERIAL_FORM : []

          nextFixedFieldIds.forEach((fieldId) => {
            if (fieldId) fixedFieldIds.add(fieldId)
          })

          nextDynamicFieldIds.forEach((fieldId) => {
            if (fieldId) dynamicFieldIds.add(fieldId)
          })
        })
      })

      mandatoryFields.MATERIAL_FIXED_FIELDS = [...fixedFieldIds]
      mandatoryFields.STANDARD_MATERIAL_FORM = [...dynamicFieldIds]

      return mandatoryFields
    },
    resolvedTemplateFields () {
      return this.templateField.map((field) => ({
        ...field,
        caption: this.normalizeTemplateFieldCaption(field?.caption || field?.field_name),
        required: Boolean(field?.required || this.isSequenceTemplateDynamicFieldRequired(field?.field_id))
      }))
    }
  },
  watch: {
    materialMaster: {
      deep: true,
      handler () {
        this.evaluateRuntimeValidationRules()
      }
    },
    dynamicFieldValues: {
      deep: true,
      handler () {
        this.evaluateRuntimeValidationRules()
      }
    },
    templateField: {
      deep: true,
      immediate: true,
      handler (fields) {
        const nextValues = { ...this.dynamicFieldValues }
        fields.forEach((field) => {
          if (!Object.prototype.hasOwnProperty.call(nextValues, field.field_id)) {
            nextValues[field.field_id] = this.getDynamicFieldDefaultValue(field)
          }
        })
        this.dynamicFieldValues = nextValues
        this.$nextTick(() => {
          this.evaluateRuntimeValidationRules()
        })
      }
    },
    sequenceIdForMaterialId () {
      this.evaluateRuntimeValidationRules()
    },
    runtimeValidationRules: {
      deep: true,
      handler () {
        this.evaluateRuntimeValidationRules()
      }
    }
  },
  methods: {
    normalizeTemplateFieldCaption (caption) {
      return typeof caption === 'string'
        ? caption.replace(/\s*\*+\s*$/, '')
        : caption
    },
    normalizeSequenceTemplateMandatoryMetadata (metadata) {
      if (Array.isArray(metadata)) {
        return metadata.find(item => item && typeof item === 'object' && !Array.isArray(item)) || {}
      }

      if (metadata && typeof metadata === 'object') {
        return metadata
      }

      return {}
    },
    isSequenceTemplateFixedFieldRequired (fieldId) {
      return this.sequenceTemplateMandatoryFields.MATERIAL_FIXED_FIELDS.includes(fieldId)
    },
    isSequenceTemplateDynamicFieldRequired (fieldId) {
      return this.sequenceTemplateMandatoryFields.STANDARD_MATERIAL_FORM.includes(fieldId)
    },
    getFixedFieldInputGroupClass (fieldId, baseClasses = []) {
      const classes = Array.isArray(baseClasses) ? [...baseClasses] : [baseClasses]
      if (this.isSequenceTemplateFixedFieldRequired(fieldId) && !classes.includes('imp')) {
        classes.push('imp')
      }
      return classes
    },
    getResolvedTemplateField (field) {
      if (!field) return field
      return this.resolvedTemplateFields.find(item => item.field_id === field.field_id) || field
    },
    getDynamicFieldDefaultValue (field) {
      const key = String(field?.form_field?.key || '').toUpperCase()
      if (['BOOLEAN', 'NUMBER', 'DATE', 'TIME', 'LONG_TEXT', 'TEXT', 'LOCATION', 'PRODUCT_CODE'].includes(key)) {
        return null
      }
      if (['CONFIGURATION_LIST', 'USER', 'MULTI_USER', 'ATTACHMENT', 'DOCUMENTS', 'MATERIALS', 'TABLE'].includes(key)) {
        return []
      }
      return null
    },
    handleDynamicFieldChange ({ field_id: fieldId, value }) {
      if (!fieldId) return
      if (this.isDynamicFieldControlledByActiveRule(fieldId)) return
      this.$set(this.dynamicFieldValues, fieldId, value)
    },
    getTemplateFieldTypeKey (fieldId) {
      const field = this.getTemplateFieldById(fieldId)
      return String(field?.form_field?.key || '').toUpperCase()
    },
    isStandardMaterialCustomListField (fieldId) {
      return this.getTemplateFieldTypeKey(fieldId) === 'CONFIGURATION_LIST'
    },
    extractCustomListSelectedValue (value) {
      if (Array.isArray(value)) {
        for (let index = value.length - 1; index >= 0; index -= 1) {
          const extractedValue = this.extractCustomListSelectedValue(value[index])
          if (extractedValue !== undefined && extractedValue !== null && extractedValue !== '') {
            return extractedValue
          }
        }
        return null
      }

      if (value && typeof value === 'object') {
        if (Object.prototype.hasOwnProperty.call(value, 'int_value')) {
          return value.int_value
        }
        if (Object.prototype.hasOwnProperty.call(value, 'string_value')) {
          return value.string_value
        }
        if (Object.prototype.hasOwnProperty.call(value, 'id')) {
          return value.id
        }
        if (Object.prototype.hasOwnProperty.call(value, 'value')) {
          return this.extractCustomListSelectedValue(value.value)
        }
      }

      return value
    },
    getStandardMaterialFormRuntimeValue (fieldId) {
      if (!fieldId) return undefined
      const rawValue = this.dynamicFieldValues[fieldId]

      if (this.isStandardMaterialCustomListField(fieldId)) {
        return this.extractCustomListSelectedValue(rawValue)
      }

      return rawValue
    },
    getStandardMaterialFormValidationContext () {
      const context = {}

      Object.keys(this.dynamicFieldValues).forEach((fieldId) => {
        context[fieldId] = this.getStandardMaterialFormRuntimeValue(fieldId)
      })

      return context
    },
    getRuleContexts () {
      return {
        MATERIAL_FIXED_FIELDS: this.materialMaster,
        STANDARD_MATERIAL_FORM: this.getStandardMaterialFormValidationContext()
      }
    },
    async loadRuntimeValidationRules () {
      if (this.view !== 'material' || this.isApplyingValidationResults) return
      try {
        const response = await getRulesApi()
        this.runtimeValidationRules = (Array.isArray(response?.validations) ? response.validations : [])
          .filter((validation) => !shouldBypassValidationRule(validation))
      } catch (err) {
        this.runtimeValidationRules = []
      }
      this.evaluateRuntimeValidationRules()
    },
    getMatchingDynamicFieldRefs (uuidKey) {
      const childComponent = this.$refs[uuidKey]
      if (!childComponent) return []
      return Array.isArray(childComponent) ? childComponent : [childComponent]
    },
    resolveInjectedValue (value) {
      if (value && typeof value === 'object' && !Array.isArray(value)) {
        return JSON.parse(JSON.stringify(value))
      }
      return value
    },
    readRuntimeValueByPath (value, path) {
      if (value == null || !path) return value
      if (typeof path !== 'string') return value[path]

      return path.split('.').reduce((acc, key) => {
        if (acc == null) return undefined
        return acc[key]
      }, value)
    },
    normalizeRuntimeLookupKey (value) {
      if (value == null) return ''
      return `${value}`.trim().toLowerCase()
    },
    getPluginFixedFieldSourceContext () {
      const sources = [
        this.pluginFixedFields,
        this.pluginContext?.PLUGIN_FIXED_FIELDS,
        this.pluginContext?.pluginFixedFields,
        this.pluginContext?.fields,
        this.pluginContext,
        this.$attrs?.pluginFixedFields,
        this.$attrs?.pluginContext?.PLUGIN_FIXED_FIELDS,
        this.$attrs?.pluginContext?.pluginFixedFields,
        this.$attrs?.pluginContext?.fields,
        this.$attrs?.pluginContext
      ].filter(source => source && typeof source === 'object' && !Array.isArray(source))

      const context = {}

      sources.forEach((source) => {
        Object.keys(source).forEach((key) => {
          const value = source[key]
          context[key] = value

          const normalizedKey = this.normalizeRuntimeLookupKey(key)
          if (normalizedKey) {
            context[normalizedKey] = value
          }
        })
      })

      return context
    },
    getSequenceTemplateSourceContext () {
      const context = {
        matched: this.matchedSequenceTemplateId,
        current: this.sequenceIdForMaterialId,
        material: this.sequenceIdForMaterialId,
        material_id: this.sequenceIdForMaterialId,
        product_code: this.sequenceIdForProductCode,
        product_code_id: this.sequenceIdForProductCode,
        material_values: this.resolveInjectedValue(this.partIdValues),
        product_code_values: this.resolveInjectedValue(this.partIdValuesForProductCode)
      }

      if (this.sequenceIdForMaterialId) {
        context[this.sequenceIdForMaterialId] = this.sequenceIdForMaterialId
      }

      if (this.sequenceIdForProductCode) {
        context[this.sequenceIdForProductCode] = this.sequenceIdForProductCode
      }

      return context
    },
    setChildComponentValue (childComponent, value) {
      if (!childComponent) return

      if (typeof childComponent.setValue === 'function') {
        childComponent.setValue(value)
        return
      }

      if (Object.prototype.hasOwnProperty.call(childComponent, 'componentValue')) {
        childComponent.componentValue = this.resolveInjectedValue(value)
      }
    },
    getTemplateFieldById (fieldId) {
      return this.templateField.find(field => field.field_id === fieldId) || null
    },
    getSequenceTemplateFixedFieldLabel (fieldId) {
      const fieldLabels = {
        material_name: this.view === 'material' ? 'Material Name' : 'Resource Name',
        material_type: 'Type',
        unit_of_material: this.view === 'material' ? 'Unit Of Material' : 'Unit Of Resource',
        plm_material_id: this.view === 'material' ? 'PLM Material Id' : 'PLM Resource Id',
        material_description: this.view === 'material' ? 'Material Description' : 'Resource Description',
        workflow_template_id: 'Workflow',
        plm_record_id: 'PLM Record Id',
        erp_material_id: this.view === 'material' ? 'ERP Material Id' : 'ERP Resource Id',
        material_group: 'Material Group',
        gross_weight: 'Gross Weight',
        weight_unit: 'Weight Unit',
        unit_cost: 'Unit Cost',
        unit_sale_price: 'Unit Sale Price',
        effective_date: 'Effective Date',
        storage_loc: 'Storage Loc'
      }

      return fieldLabels[fieldId] || fieldId
    },
    getSequenceTemplateFixedFieldValue (fieldId) {
      if (fieldId === 'workflow_template_id') {
        return this.selectedWorkFlow?.id || this.materialMaster.workflow_template_id
      }

      return this.materialMaster[fieldId]
    },
    isMandatoryFieldValueMissing (value) {
      if (Array.isArray(value)) {
        return value.length === 0
      }

      if (typeof value === 'boolean') {
        return value === null
      }

      return value === null || value === undefined || value === ''
    },
    validateSequenceTemplateMandatoryFixedFields () {
      const validationErrors = []

      this.sequenceTemplateMandatoryFields.MATERIAL_FIXED_FIELDS.forEach((fieldId) => {
        if (!Object.prototype.hasOwnProperty.call(this.materialMaster, fieldId)) return
        if (!this.isMandatoryFieldValueMissing(this.getSequenceTemplateFixedFieldValue(fieldId))) return

        validationErrors.push(`${this.getSequenceTemplateFixedFieldLabel(fieldId)} is a mandatory field`)
      })

      if (validationErrors.length > 0) {
        validationErrors.forEach(error => alert(error))
        return false
      }

      return true
    },
    coerceMaterialFixedFieldValue (fieldId, value) {
      if (value && typeof value === 'object' && Object.prototype.hasOwnProperty.call(value, 'id')) {
        return value.id
      }
      return value
    },
    getMaterialFieldDefaultValue (fieldId) {
      const materialDefaults = {
        custom_material_id: null,
        gross_weight: null,
        lead_time: null,
        material_description: null,
        material_group: null,
        resource_state: null,
        material_name: null,
        effective_date: null,
        plm_material_id: null,
        plm_record_id: null,
        unit_cost: null,
        storage_loc: null,
        unit_of_material: null,
        unit_sale_price: null,
        weight_unit: null,
        type: this.view === 'material' ? 1 : 2,
        form_id: null,
        source: 4,
        material_type: null,
        resource_type: null,
        workflow_template_id: null
      }

      return Object.prototype.hasOwnProperty.call(materialDefaults, fieldId)
        ? this.resolveInjectedValue(materialDefaults[fieldId])
        : null
    },
    syncSelectedWorkflow (workflowId) {
      if (!workflowId) {
        this.selectedWorkFlow = {}
        return
      }

      const workflow = this.workflows.find(item => item.id === workflowId)
      this.selectedWorkFlow = workflow ? { ...workflow } : { id: workflowId }
    },
    buildActiveControlledFieldsMap (evaluations) {
      const activeControlledFields = {}

      this.runtimeValidationRules.forEach((validation) => {
        if (!evaluations[validation.id]) return

        const normalizedTarget = normalizeRuleKey(validation?.target)
        const actions = Array.isArray(validation?.trigger_actions) ? validation.trigger_actions : []

        actions.forEach((action) => {
          if (normalizedTarget === 'SEQUENCE_TEMPLATE' && action?.sequence_template_id) {
            if (!activeControlledFields[normalizedTarget]) {
              activeControlledFields[normalizedTarget] = {}
            }
            activeControlledFields[normalizedTarget].selector = true
          }

          const isMapAction = normalizeRuleKey(action?.trigger_action) === 'MAP'
          const mapMetadata = Array.isArray(action?.metadata) ? action.metadata[0] || {} : {}
          const fieldId = isMapAction
            ? (mapMetadata.target_key || mapMetadata.target)
            : getActionFieldId(action?.metadata?.field)
          if (!fieldId) return

          const controlledTarget = isMapAction
            ? (Object.prototype.hasOwnProperty.call(this.materialMaster, fieldId)
              ? 'MATERIAL_FIXED_FIELDS'
              : 'STANDARD_MATERIAL_FORM')
            : normalizedTarget

          if (!activeControlledFields[controlledTarget]) {
            activeControlledFields[controlledTarget] = {}
          }

          activeControlledFields[controlledTarget][fieldId] = true
        })
      })

      return activeControlledFields
    },
    resetRuntimeValidationField (target, fieldId) {
      if (!fieldId) return

      if (target === 'MATERIAL_FIXED_FIELDS' &&
        Object.prototype.hasOwnProperty.call(this.materialMaster, fieldId)) {
        this.$set(this.materialMaster, fieldId, this.getMaterialFieldDefaultValue(fieldId))
        if (fieldId === 'workflow_template_id') {
          this.syncSelectedWorkflow(null)
        }
        return
      }

      if (target === 'STANDARD_MATERIAL_FORM' &&
        Object.prototype.hasOwnProperty.call(this.dynamicFieldValues, fieldId)) {
        const nextValue = this.getDynamicFieldDefaultValue(this.getTemplateFieldById(fieldId))
        this.$set(this.dynamicFieldValues, fieldId, nextValue)

        const childComponents = this.getMatchingDynamicFieldRefs(fieldId)
        childComponents.forEach((childComponent) => {
          this.setChildComponentValue(childComponent, nextValue)
        })
      }
    },
    resetReleasedRuntimeValidationTargets (previousControlledFields, nextControlledFields) {
      Object.keys(previousControlledFields).forEach((target) => {
        const previousFields = previousControlledFields[target] || {}
        const nextFields = nextControlledFields[target] || {}

        Object.keys(previousFields).forEach((fieldId) => {
          if (nextFields[fieldId]) return
          this.resetRuntimeValidationField(target, fieldId)
        })
      })
    },
    isFieldControlledByActiveRule (target, fieldId) {
      if (!fieldId) return false
      const normalizedTarget = normalizeRuleKey(target)
      return Boolean(this.runtimeControlledFields?.[normalizedTarget]?.[fieldId])
    },
    isMaterialFieldControlledByActiveRule (fieldId) {
      return this.isFieldControlledByActiveRule('MATERIAL_FIXED_FIELDS', fieldId)
    },
    isSequenceTemplateControlledByActiveRule () {
      return this.isFieldControlledByActiveRule('SEQUENCE_TEMPLATE', 'selector')
    },
    isDynamicFieldControlledByActiveRule (fieldId) {
      return this.isFieldControlledByActiveRule('STANDARD_MATERIAL_FORM', fieldId)
    },
    coerceDynamicFieldValue (fieldId, value) {
      const field = this.getTemplateFieldById(fieldId)
      const fieldTypeKey = String(field?.form_field?.key || '').toUpperCase()

      if (fieldTypeKey === 'CONFIGURATION_LIST') {
        if (Array.isArray(value)) {
          return [...value]
        }
        const optionId = value && typeof value === 'object' && Object.prototype.hasOwnProperty.call(value, 'id')
          ? value.id
          : value
        return optionId == null || optionId === '' ? [] : [optionId]
      }

      if (fieldTypeKey === 'NUMBER' && value !== null && value !== undefined && value !== '') {
        return Number(value)
      }

      if (fieldTypeKey === 'BOOLEAN') {
        return value === 'true' ? true : value === 'false' ? false : value
      }

      return value
    },
    resolveRuntimeActionValue (action) {
      const metadata = action?.metadata || {}
      const actionType = normalizeRuleKey(metadata?.type)
      const actionValue = getActionMetadataValue(metadata?.value)

      if (actionType === 'MAP') {
        const sourceFieldId = getActionFieldId(actionValue)
        if (!sourceFieldId) return actionValue

        if (Object.prototype.hasOwnProperty.call(this.dynamicFieldValues, sourceFieldId)) {
          return this.resolveInjectedValue(this.dynamicFieldValues[sourceFieldId])
        }

        if (Object.prototype.hasOwnProperty.call(this.materialMaster, sourceFieldId)) {
          return this.resolveInjectedValue(this.materialMaster[sourceFieldId])
        }
      }

      return this.resolveInjectedValue(actionValue)
    },
    hasMapValidationActions (validation) {
      const actions = Array.isArray(validation?.trigger_actions) ? validation.trigger_actions : []
      return actions.some(action => normalizeRuleKey(action?.trigger_action) === 'MAP')
    },
    isValidationMatchedForMapExecution (validation, evaluations) {
      if (evaluations[validation?.id]) {
        return true
      }

      const groups = Array.isArray(validation?.validation_groups) ? validation.validation_groups : []
      return !groups.length && this.hasMapValidationActions(validation)
    },
    resolveMapSourceValue (metadata = {}) {
      const source = normalizeRuleKey(metadata?.source)
      const sourceKey = metadata?.source_key

      if (!source || sourceKey == null || sourceKey === '') {
        return undefined
      }

      if (source === 'PLUGIN_FIXED_FIELDS') {
        const pluginContext = this.getPluginFixedFieldSourceContext()
        return pluginContext[sourceKey] ??
          pluginContext[this.normalizeRuntimeLookupKey(sourceKey)]
      }

      if (source === 'MATERIAL_FIXED_FIELDS') {
        return this.readRuntimeValueByPath(this.materialMaster, sourceKey)
      }

      if (source === 'STANDARD_MATERIAL_FORM') {
        return this.readRuntimeValueByPath(this.dynamicFieldValues, sourceKey)
      }

      if (source === 'SEQUENCE_TEMPLATE') {
        return this.readRuntimeValueByPath(this.getSequenceTemplateSourceContext(), sourceKey)
      }

      return undefined
    },
    applyMappedTargetValue (targetKey, value) {
      if (!targetKey || value === undefined || value === null || value === '') {
        return
      }

      if (Object.prototype.hasOwnProperty.call(this.materialMaster, targetKey)) {
        const nextValue = this.coerceMaterialFixedFieldValue(targetKey, this.resolveInjectedValue(value))
        this.$set(this.materialMaster, targetKey, nextValue)
        if (targetKey === 'workflow_template_id') {
          this.syncSelectedWorkflow(nextValue)
        }
        return
      }

      if (Object.prototype.hasOwnProperty.call(this.dynamicFieldValues, targetKey)) {
        const nextValue = this.coerceDynamicFieldValue(targetKey, this.resolveInjectedValue(value))
        this.$set(this.dynamicFieldValues, targetKey, nextValue)

        const childComponents = this.getMatchingDynamicFieldRefs(targetKey)
        childComponents.forEach((childComponent) => {
          this.setChildComponentValue(childComponent, nextValue)
        })
      }
    },
    applyMapValidationAction (action) {
      const metadata = Array.isArray(action?.metadata) ? action.metadata[0] || {} : {}
      const targetKey = metadata?.target_key || metadata?.target
      const sourceValue = this.resolveMapSourceValue(metadata)

      this.applyMappedTargetValue(targetKey, sourceValue)
    },
    applyMaterialFixedFieldAction (action) {
      const fieldId = getActionFieldId(action?.metadata?.field)
      if (!fieldId || !Object.prototype.hasOwnProperty.call(this.materialMaster, fieldId)) return
      const nextValue = this.coerceMaterialFixedFieldValue(fieldId, this.resolveRuntimeActionValue(action))
      this.$set(this.materialMaster, fieldId, nextValue)
      if (fieldId === 'workflow_template_id') {
        this.syncSelectedWorkflow(nextValue)
      }
    },
    applyStandardMaterialFormAction (action) {
      const fieldId = getActionFieldId(action?.metadata?.field)
      if (!fieldId || !Object.prototype.hasOwnProperty.call(this.dynamicFieldValues, fieldId)) return

      const nextValue = this.coerceDynamicFieldValue(fieldId, this.resolveRuntimeActionValue(action))
      this.$set(this.dynamicFieldValues, fieldId, nextValue)

      const childComponents = this.getMatchingDynamicFieldRefs(fieldId)
      childComponents.forEach((childComponent) => {
        this.setChildComponentValue(childComponent, nextValue)
      })
    },
    applySequenceTemplateAction (action) {
      const templateId = action?.sequence_template_id
      if (!templateId || this.matchedSequenceTemplateId === templateId) return
      this.matchedSequenceTemplateId = templateId

      this.$nextTick(() => {
        const previewRef = this.$refs.materialPartIdPreview
        if (previewRef && typeof previewRef.selectSequenceTemplateById === 'function') {
          previewRef.selectSequenceTemplateById(templateId)
        }
      })
    },
    applyValidationAction (target, action) {
      const normalizedTarget = normalizeRuleKey(target)
      if (normalizedTarget === 'MATERIAL_FIXED_FIELDS') {
        this.applyMaterialFixedFieldAction(action)
        return
      }

      if (normalizedTarget === 'STANDARD_MATERIAL_FORM') {
        this.applyStandardMaterialFormAction(action)
        return
      }

      if (normalizedTarget === 'SEQUENCE_TEMPLATE') {
        this.applySequenceTemplateAction(action)
      }
    },
    evaluateRuntimeValidationRules () {
      if (this.view !== 'material' || this.isApplyingValidationResults) return

      const evaluations = {}
      const contexts = this.getRuleContexts()
      this.isApplyingValidationResults = true

      this.runtimeValidationRules.forEach((validation) => {
        const isMatched = evaluateValidationRule(validation, contexts)
        evaluations[validation.id] = isMatched
      })

      const activeControlledFields = this.buildActiveControlledFieldsMap(evaluations)
      this.resetReleasedRuntimeValidationTargets(this.runtimeControlledFields, activeControlledFields)

      this.runtimeValidationRules.forEach((validation) => {
        if (!evaluations[validation.id]) return

        const actions = Array.isArray(validation?.trigger_actions) ? validation.trigger_actions : []
        actions.forEach((action) => {
          this.applyValidationAction(validation?.target, action)
        })
      })

      this.runtimeValidationRules.forEach((validation) => {
        if (!this.isValidationMatchedForMapExecution(validation, evaluations)) return

        const actions = Array.isArray(validation?.trigger_actions) ? validation.trigger_actions : []
        actions.forEach((action) => {
          if (normalizeRuleKey(action?.trigger_action) !== 'MAP') return
          this.applyMapValidationAction(action)
        })
      })

      this.runtimeValidationEvaluations = evaluations
      this.runtimeControlledFields = activeControlledFields
      this.$nextTick(() => {
        this.isApplyingValidationResults = false
      })
    },
    handleWorkFlowSelection (workflow) {
      this.selectedWorkFlow = workflow
      this.materialMaster.workflow_template_id = workflow?.id || null
    },
    handleSequenceIdSelection (id) {
      if (id !== this.matchedSequenceTemplateId) {
        this.matchedSequenceTemplateId = null
      }
      this.sequenceIdForMaterialId = id
    },
    handleSequenceIdSelectionForProductCode (id) {
      this.sequenceIdForProductCode = id
    },
    handleTogglePartIdGenerationForProductCode () {
      this.productCode = !this.productCode
      if (this.productCode) {
        this.checkForDuplicateProductCode()
      }
    },
    getWorkflows () {
      this.WFTLoading = true
      getFullWorkFLowTemplates([config.CORE_FEATURES.MATERIAL], '', [config.WORKFLOW_TYPES_INVERTED.PROCESS_PLAN]).then((res) => {
        this.workflows = res.workflow_templates
      }).catch(() => {
        this.workflows = []
      }).finally(() => {
        this.WFTLoading = false
      })
    },
    findUsedCustomListIds (templateVersions) {
      const configIdSet = new Set()
      for (const templateVersion of templateVersions) {
        for (const field of templateVersion.template_fields) {
          if (field.field_type_id === config.FORM_TYPE.CONFIGRATION_LIST) {
            configIdSet.add(field.custom_list_id)
          }
        }
      }
      return configIdSet
    },
    async getGivenCustomList (ids) {
      const customListData = await getGivenCustomListsData(ids)
      const customListMap = {}
      for (const customList of customListData.core_custom_list) {
        customListMap[customList.id] = customList.custom_list_values
      }
      this.$store.dispatch('form/saveCustomListMap', customListMap)
    },
    toggleProductCode () {
      this.productCode = !this.productCode
    },
    updatePartIdValues (values, copyMaterialName) {
      this.partIdValues = values
      this.sequenceAsName = copyMaterialName
      let isEveryValueFilled = true
      let isAutoSequenceOrUUID = false
      let valueForMaterialIdCheck = ''
      let extendedValueForMaterialId = ''
      for (const value of this.partIdValues) {
        valueForMaterialIdCheck = valueForMaterialIdCheck + value.displayValue + (value.delimiter ? value.delimiter : '')
        extendedValueForMaterialId = extendedValueForMaterialId + (value.extendedValue || value.displayValue) + (value.delimiter ? value.delimiter : '')
        if (!value.value) {
          isEveryValueFilled = false
        }
        if (value.caption === 'Auto Sequence' || value.caption === 'UUID') {
          isAutoSequenceOrUUID = true
        }
      }
      this.isEveryValueFilledForMaterialId = isEveryValueFilled
      if (copyMaterialName && this.view === 'material') {
        this.materialMaster.material_name = extendedValueForMaterialId
      }
      if (isEveryValueFilled && !isAutoSequenceOrUUID) {
        startGlobalCursorLoader()
        CheckCustomMaterialIdExistence(valueForMaterialIdCheck).then((res) => {
          if (res.core_material_master.length > 0) {
            alert(`The generated ${this.view === 'material' ? 'Material' : 'Resource'} Id already exists. Please modify the input values to generate a unique ${this.view === 'material' ? 'Material' : 'Product'} Id.`)
          }
        }).catch(() => {
          alert(`Error while validating the generated ${this.view === 'material' ? 'Material' : 'Resource'} Id. Please try again.`)
        }).finally(() => {
          stopGlobalCursorLoader()
        })
      }
    },
    updatePartIdValuesForProductCode (values, sequenceId) {
      this.partIdValuesForProductCode = values
      if (this.productCode) {
        this.checkForDuplicateProductCode()
      }
    },
    checkForDuplicateProductCode () {
      let isEveryValueFilled = true
      for (const value of this.partIdValuesForProductCode) {
        if (!value.value) {
          isEveryValueFilled = false
          break
        }
      }
      if (isEveryValueFilled) {
        startGlobalCursorLoader()
        let valueForProductCodeCheck = ''
        for (const value of this.partIdValuesForProductCode) {
          valueForProductCodeCheck = valueForProductCodeCheck + value.displayValue + (value.delimiter ? value.delimiter : '')
        }
        CheckProductCodeExistence(valueForProductCodeCheck).then((res) => {
          if (res.product_code.length > 0) {
            alert('The generated Product Code already exists. Please modify the input values to generate a unique Product Code.')
          }
        }).catch(() => {
          alert('Error while validating the generated Product Code. Please try again.')
        }).finally(() => {
          stopGlobalCursorLoader()
        })
      }
    },
    changeNumber (event) {
      if (['e', 'E', '+', '-'].includes(event.key)) {
        restrictKeys(event)
      }
    },
    validateSetupTimeFields () {
      const hasSetupTimeValue =
        this.materialMaster.setup_time !== null &&
        this.materialMaster.setup_time !== undefined &&
        this.materialMaster.setup_time !== ''
      const hasSetupTimeDurationType =
        this.materialMaster.setup_time_duration_type !== null &&
        this.materialMaster.setup_time_duration_type !== undefined &&
        this.materialMaster.setup_time_duration_type !== ''

      if (hasSetupTimeValue !== hasSetupTimeDurationType) {
        alert('Please provide both Setup Time value and Setup Time unit.')
        return false
      }
      return true
    },
    checkData () {
    },
    resetForm () {
      this.materialMaster = {
        custom_material_id: null,
        gross_weight: null,
        lead_time: null,
        material_description: null,
        material_group: null,
        material_name: null,
        plm_material_id: null,
        plm_record_id: null,
        effective_date: null,
        unit_cost: null,
        storage_loc: null,
        unit_of_material: null,
        unit_sale_price: null,
        weight_unit: null,
        source: 4,
        workflow_template_id: null
      }
      this.productCodeName = ''
      this.selectedWorkFlow = {}
      this.dynamicFieldValues = {}
      this.runtimeValidationEvaluations = {}
      this.runtimeControlledFields = {}
      this.matchedSequenceTemplateId = null
    },
    handleFileSelection (selectedFileData) {
      // the selectedfiles data is comming from modal (contains  all the datat related to selected docs)
      this.documentSelectDialog = false
      this.selectedFileData = selectedFileData.filter((element) => {
        if (element?.flag && element?.flag === 'deleted') { } else {
          return element
        }
      })
    },
    getLatestVersion (versions = []) {
      if (!Array.isArray(versions) || !versions.length) {
        return null
      }
      const versionsWithDate = versions.filter(version => version?.created_on)
      if (versionsWithDate.length) {
        return versionsWithDate.reduce((latest, current) => {
          return new Date(current.created_on) > new Date(latest.created_on) ? current : latest
        })
      }
      return versions[0]
    },
    getDocumentVersionId (file, docId) {
      const versions = file?.core_document?.associated_versions || file?.associated_versions || []
      const latestAssociatedVersionId = this.getLatestVersion(versions)?.id
      return file?.version_id || latestAssociatedVersionId || file?.document_version?.id || docId
    },
    async submitForm () {
      const form = this.$refs
      const formValue = {}
      this.validationErrors = []
      let isValid = true // Track if the form is valid
      for (const key of Object.keys(form)) {
        const field = form[key]?.[0]
        if (!field?.data) continue
        this.validateInputData(field?.data, form)
        if (field?.validateSelection) {
          const isSelectionValid = await field.validateSelection()
          if (!isSelectionValid) {
            this.validationErrors.push(`${field.data.caption} must use a last child selection`)
          }
        }
        if (form[key].length && form[key][0]?.data?.autogenerated === false) {
          formValue[key] = form[key][0].componentValue
        }
      }
      if (this.validationErrors.length > 0) {
        isValid = false
        this.validationErrors.forEach(error => alert(error))
        return
      }
      const inputPayload = []
      Object.keys(formValue).forEach((key) => {
        if (formValue[key] !== undefined && formValue[key] !== null) {
          if (formValue[key] !== 0 && formValue[key].length !== 0) {
            inputPayload.push({
              field_id: key,
              value: formValue[key]
            })
          }
        }
      })
      const body = [{
        templateId: this.templateId,
        dueDate: new Date().toISOString().split('T')[0],
        inputPayload: inputPayload,
        status: 1
      }]
      if (inputPayload.length > 0) {
        await SaveFormData(body, this.isOnProjectLevel).then((res) => {
          if (res.message === 'Unable to save form') {
            alert(res.message)
          }
          this.materialMaster.form_id = res.insertedFormIds[0]
        // this means you are uploading a material custom field form
        })
      }
      return isValid
    },
    validateInputData (formInput, form) {
      const componentValue = form[formInput.field_id]?.[0]?.componentValue

      if (formInput?.form_field?.key === 'USER') {
        if (formInput.required && (!componentValue || !componentValue.length)) {
          this.validationErrors.push(`${formInput.caption} is a mandatory field`)
        }
      }
      if (formInput?.form_field?.key === 'BOOLEAN') {
        // we are comparing the value to null instead of checking if it is a falsy value cause the boolean component value will false in one case and it is valid value
        if (formInput.required && componentValue === null) {
          this.validationErrors.push(`${formInput.caption} is a mandatory field`)
        }
        return
      } else if (Array.isArray(componentValue)) {
        if (formInput.required && componentValue.length < 1) {
          this.validationErrors.push(`${formInput.caption} is a mandatory field`)
        }
        return
      }
      if (formInput.required && !componentValue) {
        this.validationErrors.push(`${formInput.caption} is a mandatory field`)
      }
    },
    async validateForm () {
      const form = this.$refs
      const formValue = {}
      this.validationErrors = []

      for (const key of Object.keys(form)) {
        const field = form[key]?.[0]
        const component = field?.data

        if (!field || !component) continue

        this.validateInputData(component, form)
        if (field.validateSelection) {
          const isSelectionValid = await field.validateSelection()
          if (!isSelectionValid) {
            this.validationErrors.push(`${component.caption} must use a last child selection`)
          }
        }
        if (component?.key === 'TABLE' || component?.form_field?.key === 'TABLE') {
          const isTableValid = await field.saveFormTemplate()
          if (!isTableValid) return false
        }

        if (component.autogenerated === false) {
          formValue[key] = field.componentValue
        }
      }
      if (this.validationErrors.length > 0) {
        this.validationErrors.forEach(error => alert(error))
        return false
      }
      const inputPayload = Object.keys(formValue)
        .filter(key => {
          const val = formValue[key]
          return (
            val !== undefined &&
        val !== null &&
        !(Array.isArray(val) && val.length === 0)
          )
        })
        .map(key => ({
          field_id: key,
          value: formValue[key]
        }))
      return inputPayload
    },
    validatePartIdValues () {
      let isValid = true
      for (const value of this.partIdValues) {
        if (!value.value) {
          alert(`Please enter a value for ${value.caption} in material id`)
          isValid = false
        }
      }
      return isValid
    },
    validatePartIdValuesForProductCode () {
      let isValid = true
      for (const value of this.partIdValuesForProductCode) {
        if (!value.value) {
          alert(`Please enter a value for ${value.caption} in product code`)
          isValid = false
        }
      }
      return isValid
    },
    async validateTagSelections () {
      if (!this.$refs.tagSelector?.validateSelection) return true
      const isValid = await this.$refs.tagSelector.validateSelection()
      if (!isValid) {
        alert('Please select the last child tag before continuing.')
      }
      return isValid
    },
    async createMaterialMasterNew () {
      const loader = new Loader()
      try {
        this.buttonDisabled = true
        if (!await this.validateTagSelections()) {
          this.buttonDisabled = false
          return
        }
        if (!this.validateSetupTimeFields()) {
          this.buttonDisabled = false
          return
        }
        if (!this.validatePartIdValues()) {
          this.buttonDisabled = false
          return
        }
        if (this.view === 'material') {
          if (this.productCode && !this.validatePartIdValuesForProductCode()) {
            this.buttonDisabled = false
            return
          }
        }
        const skipMaterialIdCheck = true
        if (skipMaterialIdCheck) {
          this.materialMaster.custom_material_id = undefined
        }
        if (!MaterialMasterValidation(this.materialMaster, skipMaterialIdCheck)) {
          this.buttonDisabled = false
          return
        }
        if (!this.validateSequenceTemplateMandatoryFixedFields()) {
          this.buttonDisabled = false
          return
        }
        if (!this.materialMaster.material_type && this.view === 'material') {
          alert('Material type is required')
          this.buttonDisabled = false
          return
        }
        if (this.bomForm && !this.productCodeName.length && !this.showProductPartIdPreview) {
          alert('Product Code is Missing')
          this.buttonDisabled = false
          return
        }
        loader.show()
        this.materialMaster.form_id = undefined
        if (this.selectedWorkFlow?.id) {
          this.materialMaster.workflow_template_id = this.selectedWorkFlow.id
        }
        if (this.view === 'material') {
          this.materialMaster.resource_group = undefined
          this.materialMaster.resource_state = undefined
        } else {
          this.materialMaster.material_group = undefined
          this.materialMaster.resource_state = undefined
        }
        const docInput = this.selectedFileData
          .map((file) => {
            const docId = file?.core_document?.id || file?.id
            const versionId = this.getDocumentVersionId(file, docId)
            if (!docId || !versionId) return null
            return {
              document_id: docId,
              version_id: versionId
            }
          })
          .filter(Boolean)
        const body = {
          productCodeInput: this.productCodeName.length ? this.productCodeName.trim() : undefined,
          tagInput: [],
          materialInput: this.materialMaster,
          customFieldInput: [],
          sequenceAsName: this.sequenceAsName
        }
        if (docInput.length > 0) {
          body.docInput = docInput
        }
        for (const tagArray of this.tagGroupData.tagArray) {
          for (const tag of tagArray) {
            body.tagInput.push(tag.id)
          }
        }
        const customFieldData = await this.validateForm()
        if (customFieldData) {
          body.customFieldInput = customFieldData
        } else {
          this.buttonDisabled = false
          loader.hide()
          return
        }
        if (this.sequenceIdForMaterialId) {
          const sequenceInput = this.partIdValues.map((value) => {
            return {
              value: value.value,
              delimiter: value.delimiter,
              sequence: value.sequence
            }
          })
          body.sequenceInput = sequenceInput
          body.sequenceTemplateId = this.sequenceIdForMaterialId
        }
        if (this.productCode && this.sequenceIdForProductCode && this.view !== 'resource') {
          const sequenceInput = this.partIdValuesForProductCode.map((value) => {
            return {
              value: value.value,
              delimiter: value.delimiter,
              sequence: value.sequence
            }
          })
          body.productCodeSequenceInput = sequenceInput
          body.productCodeSequenceTemplateId = this.sequenceIdForProductCode
        } else {
          body.productCodeSequenceInput = []
        }
        await createMaterialMaster(body)
        success('Material Master Data Created successfully')
        // this.productCode && this.partIdRulesForProductCode.length to identify whether the material created had product code or not
        this.$emit('close', this.productCode || this.showProductPartIdPreview)
        this.resetForm()
      } catch (err) {
        alert(err.graphQLErrors[0]?.message ?? 'Unable to create material master')
      } finally {
        this.buttonDisabled = false
        loader.hide()
      }
    },
    async createMaterialMaster () {
      this.buttonDisabled = true
      if (!await this.validateTagSelections()) {
        this.buttonDisabled = false
        return
      }
      if (!MaterialMasterValidation(this.materialMaster)) {
        this.buttonDisabled = false
        return
      }
      if (!this.validateSequenceTemplateMandatoryFixedFields()) {
        this.buttonDisabled = false
        return
      }
      if (this.bomForm && !this.productCodeName.length) {
        alert('Product Code is Missing')
        this.buttonDisabled = false
        return
      }
      const isFormValid = await this.submitForm()
      if (!isFormValid) {
        this.buttonDisabled = false
        return
      }
      const loader = new Loader()
      loader.show()
      if (this.productCodeName.length) {
        const body = {
          product_code: this.productCodeName
        }
        await CheckMaterialID(this.materialMaster.custom_material_id)
          .then((data) => {
            if (data.core_material_master.length !== 0) {
              alert('Material ID exists in Material Master. Please enter a unique Material ID')
              this.buttonDisabled = false
              loader.hide()
            } else {
              CreateProductCodeData(body)
                .then((res) => {
                  // const id = res.insert_product_code_one.id
                  // this.materialMaster.product_code = id
                  if (this.view === 'material') {
                    this.materialMaster.resource_group = undefined
                  } else this.materialMaster.material_group = undefined
                  CreateMaterialMasterData(this.materialMaster)
                    .then((res) => {
                      const materialId = res.insert_core_material_master_one.id
                      this.attachDocumentTomaterial(materialId)
                      const tags = [...this.selectedTags, ...this.getTags]
                      if (tags?.length) {
                        const tagMaterials = tags.map(tag => {
                          return {
                            tag_id: tag.id,
                            material_id: materialId
                          }
                        })
                        AddMaterialTags(tagMaterials)
                          .then(() => {
                            success('Material Master Data Created successfully')
                            this.$emit('created', {
                              ...this.materialMaster,
                              product_code_name: this.productCodeName
                            })
                            this.resetForm()
                            loader.hide()
                          })
                          .catch(() => {
                            alert('Something went wrong')
                            this.buttonDisabled = false
                            loader.hide()
                          })
                      } else {
                        success('Material Master Data Created successfully')
                        this.$emit('created', {
                          ...this.materialMaster,
                          product_code_name: this.productCodeName
                        })
                        this.resetForm()
                        loader.hide()
                      }
                    })
                    .catch(() => {
                      alert('Something went wrong')
                      this.buttonDisabled = false
                      loader.hide()
                    })
                })
                .catch((err) => {
                  if (err.message.includes('unique_product_code_validation')) {
                    alert('Product code already exists')
                    this.buttonDisabled = false
                  } else {
                    this.buttonDisabled = false
                    alert('Something went wrong')
                  }
                  loader.hide()
                })
            }
          })
          .catch(() => {
            alert('Something went wrong')
            this.buttonDisabled = false
            loader.hide()
          })
      } else {
        if (this.view === 'material') {
          this.materialMaster.resource_group = undefined
        } else this.materialMaster.material_group = undefined
        await CreateMaterialMasterData(this.materialMaster)
          .then((res) => {
            this.attachDocumentTomaterial(res?.insert_core_material_master_one?.id)
            const materialId = res.insert_core_material_master_one.id
            if (this.tagGroupData.tagArray) {
              const tagMaterials = []
              for (const tagArray of this.tagGroupData.tagArray) {
                for (const tag of tagArray) {
                  tagMaterials.push({
                    tag_id: tag.id,
                    material_id: materialId
                  })
                }
              }
              // here we are deleteing all tags associated with  given material is deleted and then new tags will attached
              AddMaterialTags(tagMaterials)
                .then(() => {
                  success('Material Master Data Created successfully')
                  loader.hide()
                  this.$emit('close')
                })
                .catch((err) => {
                  this.buttonDisabled = false
                  if (err.message.includes('tag_material_pkey')) {
                    alert('Tag Already attached!')
                  } else {
                    alert('Something went wrong')
                  }
                  loader.hide()
                })
            } else {
              success('Material Master Data Created successfully')
              this.$emit('close')
              this.resetForm()
              loader.hide()
            }
          })
          .catch((err) => {
            this.buttonDisabled = false
            if (err.message.includes('core_material_master_custom_material_id_tenant_id_key')) {
              alert('Material ID already exists. Please enter a unique Material ID')
              this.materialMaster.custom_material_id = null
            } else {
              alert('Something went wrong')
            }
            loader.hide()
          })
      }
    },
    async attachDocumentTomaterial (materialId) {
      try {
        const materialAttch = []
        this.selectedFileData.forEach((element) => {
          if (element?.flag === 'deleted') {} else { materialAttch.push({ document_id: element.id, material_id: materialId }) }
        })
        if (materialAttch.length > 0) {
          await attachDocToMaterail(materialAttch)
        }
      } catch (error) {
        console.log(error)
      }
      // docId contains all the id of selected documnents
    },
    createEffectiveDate (dateValue) {
      this.materialMaster.effective_date = dateValue
    },
    ...mapMutations('tag', ['addNewTag', 'updateTags']),
    normalizeDropdownValue (value) {
      if (value === null || value === undefined || value === '') return value
      const parsedValue = Number(value)
      return Number.isNaN(parsedValue) ? value : parsedValue
    },
    findOptionById (list = [], value) {
      if (value === null || value === undefined || value === '') return {}
      const normalizedValue = this.normalizeDropdownValue(value)
      return list.find(item => this.normalizeDropdownValue(item.id) === normalizedValue) || {}
    },
    handleMaterialTypeSelection (option) {
      this.materialMaster.material_type = option?.id ?? null
      if (this.materialMaster.material_type === this.materialType.Buy) {
        this.selectedWorkFlow = {}
        this.materialMaster.workflow_template_id = null
      }
    },
    handleUnitOfMaterialSelection (option) {
      this.materialMaster.unit_of_material = option?.id ?? null
    },
    handleMaterialGroupSelection (option) {
      this.materialMaster.material_group = option?.id ?? null
    },
    handleResourceTypeSelection (option) {
      this.materialMaster.resource_type = option?.id ?? null
    },
    handleSetupTimeDurationTypeSelection (option) {
      this.materialMaster.setup_time_duration_type = option?.id ?? null
    },
    handleWeightUnitSelection (option) {
      this.materialMaster.weight_unit = option?.id ?? null
    },
    handleStorageLocationSelection (option) {
      this.materialMaster.storage_loc = option?.id ?? null
    },
    toggleMore () {
      this.moreInput = !this.moreInput
    },
    listOfUnitOfMaterial () {
      UnitOfMaterial().then((res) => {
        this.list_of_unit_of_material = res.custom_list_values.map((item) => {
          if (item.name === 'Hours (hrs)') {
            if (this.view === 'resource') {
              this.materialMaster.unit_of_material = item.name
              this.materialMaster.unit_of_material = item.id
            }
            this.resourceUnit = item
          }
          return {
            name: item.name,
            id: item.id
          }
        }).filter(
          unit => unit.name !== 'Hours (hrs)'
        )
      })
    },
    listOfWeightUnit () {
      WeightUnit().then((res) => {
        this.list_of_weight_unit = res.custom_list_values.map((item) => {
          return {
            name: item.name,
            id: item.id
          }
        })
      })
    },
    materialCustomType () {
      GetMaterialCustomList().then((res) => {
        this.customListType = res.custom_list_values
      })
    },
    listOfMaterialGroup () {
      if (this.view === 'material') {
        this.materialName = 'Material Group'
        ResourceGroup(this.materialName).then((res) => {
          this.list_of_material_group = res.custom_list_values.map((item) => {
            return {
              name: item.name,
              id: item.id
            }
          })
        })
      } else {
        this.materialName = 'Resource Group'
        getResourceTypes().then((res) => {
          this.list_of_material_group = res.custom_list_values.map((item) => {
            return {
              name: item.name,
              id: item.id
            }
          })
        })
      }
    },
    listOfAddressLocation () {
      AddressLocation().then((res) => {
        this.list_of_address_location = res.address_locations
      })
    },
    removeAttachedTags (tagId) {
      this.tagTrie.deleteTagById2(tagId)
      this.tagGroupData = this.tagTrie.groupTagInArray()
    },
    sethoveredtag (cindex, index) {
      this.hoverd_tag.cindex = cindex
      this.hoverd_tag.index = index
    },
    normalizeRowPayload (payload) {
      if (payload && typeof payload === 'object' && !Array.isArray(payload)) {
        return payload
      }
      return { id: payload, rowIndex: this.selected_tag_line }
    },
    addnewTag (payload) {
      const { tag, rowIndex } = this.normalizeRowPayload(payload)
      if (typeof rowIndex === 'number') {
        this.selected_tag_line = rowIndex
      }
      if (!tag) return
      this.tagTrie.insertTag({ name: tag.name, id: tag.id, parentId: tag.parentId ?? tag.parent_id })
      this.tagGroupData = this.tagTrie.groupTagInArray()
    },
    changeSelectedTagLine (payload) {
      const { id, rowIndex } = this.normalizeRowPayload(payload)
      if (typeof rowIndex === 'number') {
        this.selected_tag_line = rowIndex
      }
      if (id === null) {
        if (typeof rowIndex !== 'number') this.selected_tag_line = 0
      } else {
        this.tagGroupData.tagArray.forEach((element, index) => {
          if (element[0].id === id) { this.selected_tag_line = index }
        })
      }
    },
    resetSelectedTagLine (payload) {
      const { rowIndex } = this.normalizeRowPayload(payload)
      if (typeof rowIndex === 'number') {
        this.selected_tag_line = rowIndex
      }
      const currentLine = this.tagGroupData?.tagArray?.[this.selected_tag_line] || []
      if (currentLine.length) {
        this.tagTrie.deleteTagById2(currentLine[0].id)
        this.tagGroupData = this.tagTrie.groupTagInArray()
      }
      this.selected_tag_line = 0
    },
    focusTagLevel (payload) {
      const { index, rowIndex } = this.normalizeRowPayload(payload)
      if (typeof rowIndex === 'number') {
        this.selected_tag_line = rowIndex
      }
      const currentLine = this.tagGroupData?.tagArray?.[this.selected_tag_line] || []
      if (!currentLine.length || typeof index !== 'number') return
      const tagsToRemove = currentLine.slice(index)
      for (let i = tagsToRemove.length - 1; i >= 0; i--) {
        this.tagTrie.deleteTagById2(tagsToRemove[i].id)
      }
      this.tagGroupData = this.tagTrie.groupTagInArray()
    },
    keyPress (e) {
      const activeElement = this.window.document.activeElement.tagName.toLowerCase()
      const activeElementCheck = ['input', 'select', 'textarea'].includes(activeElement)
      if (e instanceof KeyboardEvent && e.code === 'Enter' && activeElement !== 'button') {
        this.window.document.activeElement.blur()
      }
      if (!this.open || activeElementCheck || this.buttonDisabled) return
      if (e instanceof KeyboardEvent && e.code === 'Enter') {
        this.createMaterialMasterNew()
      }
    },
    async getSTFtempId () {
      if (this.tenantDefaultsData?.material_temp_id) {
        this.templateId = this.tenantDefaultsData.material_temp_id
        return
      }
      const res = await GetTenantConfigTypes()
      const tenantDefaults = res.tenant_defaults?.[0]
      this.$store.commit('setTenentDefaults', tenantDefaults)
      this.templateId = tenantDefaults.tenant_feature_configuration.MATERIAL?.FORM_TEMPLATE_DEFAULT
    },
    async getFormTemplateData () {
      this.loading = true
      await getDetailFormTemplate(this.templateId).then((res) => {
        this.formTemplateData = res.core_form_templates_by_pk
        this.loading = false
      })
    }
  },
  async mounted () {
    if (this.bomForm) {
      this.productCode = true
    }
    if (this.view === 'material') {
      this.materialMaster.type = 1
    } else {
      this.materialMaster.type = 2
    }
    // const tenantDefaultsRes = await getTenantDefaults()
    // const productCodeFeatureSeq = tenantDefaultsRes.tenant_defaults[0].tenant_feature_configuration?.PRODUCT_CODE?.SEQUENCE_TEMPLATE_DEFAULT
    // const materialFeatureSeq = tenantDefaultsRes.tenant_defaults[0].tenant_feature_configuration?.MATERIAL?.SEQUENCE_TEMPLATE_DEFAULT
    // if (productCodeFeatureSeq) {
    //   const res = await GetIdGenerationRulesByFeatureId(productCodeFeatureSeq)
    //   this.partIdRulesForProductCode = res.id_generation_rules
    // }
    // if (materialFeatureSeq) {
    //   const res = await GetIdGenerationRulesByFeatureId(materialFeatureSeq)
    //   this.partIdRules = res.id_generation_rules
    // }
    ResourceState().then(res => {
      res.custom_list_values.forEach(value => {
        if (value.name === 'IDLE') {
          this.materialMaster.resource_state = value.id
        }
        this.resource_states = res.custom_list_values
      })
    })
    this.materialType = config.MATERIAL_TYPES
    this.getWorkflows()
    this.listOfUnitOfMaterial()
    this.listOfWeightUnit()
    this.listOfMaterialGroup()
    this.listOfAddressLocation()
    await this.getSTFtempId()
    await this.getFormTemplateData()
    await this.loadRuntimeValidationRules()
    this.materialCustomType()
  },
  created () {
    document.body.addEventListener('keydown', this.keyPress)
  },
  beforeDestroy () {
    document.body.removeEventListener('keydown', this.keyPress)
  }
}
</script>

<style lang="scss" scoped >
.material-master-create {
  width: 600px;
  max-height: 70vh;
  padding-right: 5px;
  overflow-y: auto;
  .sequence-template-rule-locked ::v-deep .sequence-template-container {
    pointer-events: none;
  }
  .sequence-template-rule-locked ::v-deep .sequence-template-container .dropdown-btn,
  .sequence-template-rule-locked ::v-deep .sequence-template-container .custom-dropdown {
    opacity: 0.6;
  }
  ::v-deep .form-input__asterisk {
    color: var(--brand-color-1);
  }
  .sequence-template-effective-date.imp ::v-deep .input-group label::after {
    content: '*';
    color: var(--brand-color-1);
    font-size: 1.2em;
    margin-left: 0.1em;
  }
  .document-attach{
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: wrap;
    width: 100%;
    max-height: 100px;
    min-height: 50px;
    // border-radius: 4px;
    // border: 2px solid rgba(var(--brand-rgb),0.4);
    cursor: pointer;
    &-view{
      display: flex;
      flex-wrap: wrap;
      gap: 5px;

    }
    &-edit{
      border: 2px solid rgba(0, 0,0,.3);
      border-radius: 3px;
      padding: 4px 6px;
      width: 25px;
      display: flex;
      justify-content: center;
      margin-left: 5px;
    }
    &-list{
      border: 2px solid rgba(var(--brand-rgb));;
      border-radius: 3px;
      padding: 5px 5px 5px 5px ;
    width: 100px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    cursor:context-menu;
          cursor: pointer;
      user-select: none;
      background-color: transparent;
    }
    span{
      cursor: pointer;
      user-select: none;
      background-color: transparent;
    }
  }
}
.tags {
  display: flex;
flex-wrap: wrap;
margin-left: 5px;
  margin-right: 5px;
  row-gap: 5px;
   &-line-selected{
    background-color: var(--brand-light-color);
   border: .4px solid var(--brand-color);
   border-radius: 5px;
   min-width: min-content;
   }
}
.tag-container {
  margin-top: 4px;
}

.no-tag-found{
  margin-left: 5px;
}
.attached-tags{
  cursor:pointer;
  background-color: var(--brand-color);
  padding: 0.6rem;
  font-size: small;
  border-radius: 0.4rem;
position:relative;
  &-fade{
background-color: rgb(0, 0,0,.6) ;
color:white
}
  & img{
 z-index:4;
  }
  & img{
    display: none;
  }
}
.tags-line{
  text-overflow: ellipsis;
  overflow: hidden;
   white-space: nowrap;
  & img{
    margin-inline: .5rem;
  }
  &-first-img{
    display: none;
  }
  .attached-tags:hover > img {
display: block;
scale: 1.2;
// -webkit-box-shadow:0px 0px 123px 21px rgba(215,224,221,0.78);
// -moz-box-shadow: 0px 0px 123px 21px rgba(215,224,221,0.78);
// box-shadow: 0px 0px 123px 21px rgba(215,224,221,0.78);
  }
  .attachedTags_overLay{
    background-color: black;
    position: absolute;
    width: 100%;
    height: 100%;
    border-radius: 5px;
    opacity: .3;
    z-index: 1;
  }
}
</style>
